import { getDocs, query, collection } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { LocaleCode, languages as defaultLanguages } from "../types/languages";

export interface Language {
  id: LocaleCode;
  name: string;
}

export const getLanguages = async (): Promise<Language[]> => {
  try {
    const languagesQuery = query(collection(db, "languagesAssistants"));
    const languagesSnapshot = await getDocs(languagesQuery);

    const languagesMap = new Map<string, Language>();

    defaultLanguages.forEach((lang) => {
      languagesMap.set(lang.id, lang);
    });

    languagesSnapshot.forEach((doc) => {
      const data = doc.data();
      if (
        data.code &&
        !defaultLanguages.some((lang) => lang.id === data.code)
      ) {
        languagesMap.set(data.code, {
          id: data.code as LocaleCode,
          name: data.name,
        });
      }
    });

    return Array.from(languagesMap.values());
  } catch (error) {
    console.error("Error fetching languages:", error);
    return defaultLanguages;
  }
};
